import { createSlice } from "@reduxjs/toolkit";
import { deleteTemplateThunk } from "./templateThunk";
const initialState: any = {
    template: {
        templateData: {},
        loading: true,
        error: false,
    }
}
const templateSlice = createSlice({
    name: 'template',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(deleteTemplateThunk.pending, (state) => {
                // state.template.loading = true;
                // state.template.error = null;
            })
            .addCase(deleteTemplateThunk.fulfilled, (state) => {
                // state.template.templateData = action.payload;
                // state.template.loading = false;
            })
            .addCase(deleteTemplateThunk.rejected, (state, action) => {
                // state.template.loading = false;
                // state.template.error = action.error.message || 'Something went wrong';
            });
    },
})

export default templateSlice.reducer